import {AbstractModel, JsonObject, JsonProperty, DateConverter} from 'projects/core/src/public-api';

@JsonObject('model.MissingEstimateProject')
export class MissingEstimateProject extends AbstractModel {
  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'number')
  number: string;

  @JsonProperty(String, 'name')
  name: string;

  @JsonProperty(DateConverter, 'date')
  date: Date;
}

